import React from "react";
import "./About.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useLanguage } from "../LanguageContext";

import image1 from "../images/image1.jpg"; // Ensure the image path is correct

const About = () => {
  const { language } = useLanguage();

  return (
    <section className="about">
      <div className="about-content">
        <h1>{language === 'ar' ? 'هاجر أوحسين' : language === 'fr' ? 'Hajar Ouhsine' : 'Hajar Ouhsine'}</h1>
        <h2>{language === 'ar' ? 'مهندسة وكاتبة' : language === 'fr' ? 'Ingénieure & Autrice' : 'Engineer & Author'}</h2>
        <div className={language === 'ar' ? "about-text-ar" : language === 'fr' ? "about-text-fr" : "about-text-en"}>
          {language === 'ar' ? (
            <>
              <p>
                هاجر أوحسين، من مواليد 7 يوليو 1998 بمدينة مكناس، كاتبة ومهندسة مغربية. حصلت على دبلوم مهندسة دولة في الطبوغرافيا عام 2021، لتجمع في مسارها بين الصرامة العلمية للهندسة والحساسية الأدبية الفريدة.
              </p>
              <p>
                يعكس مسارها شغفا عميقا بالثقافة والأدب والعمل الجمعوي، حيث تنشط في عدة جمعيات ثقافية واجتماعية، وتعمل في مجالات التطوع والتسيير الثقافي. شاركت هاجر في العديد من الفعاليات، من بينها ورشات كتابة ومسابقات أدبية، أبرزها مخيم الزيتون للكتابة الإبداعية. هذا الالتزام الاجتماعي والتشبث بالحوار بين الثقافات، إلى جانب خبرتها في الترجمة بين اللغتين الإنجليزية والعربية، يغذي كتابة تستكشف ثنايا الوجود.
              </p>
              <p>
                بعد إصدارها لعملين أدبيين باللغة العربية هما أضغاث أحلام (2021) وكواليا (2022)، ومشاركتها في عدة كتب جماعية، تبدأ هاجر مرحلة جديدة في مسيرتها من خلال نشرها في فرنسا لكتاب Habiter le presque (2026)، وهو ديوان شعري مصور صادر عن دار النشر Le Lys Bleu. ومن خلال هذا العمل، تدعو القارئ إلى الإقامة في تلك التفاصيل الصغيرة العابرة التي تصنع شاعرية الحياة.
              </p>
            </>
          ) : language === 'fr' ? (
            <p>
              Hajar Ouhsine conjugue la rigueur scientifique de l'ingénierie à une sensibilité littéraire singulière. Son parcours, marqué par un engagement associatif et un attachement au dialogue interculturel, nourrit une écriture qui explore les interstices de l'existence.
              <br /><br />
              Après avoir publié plusieurs ouvrages dont Qualia (2022) et Fragments de rêves (2021), elle marque une nouvelle étape dans sa carrière avec la publication en France de "Habiter le presque" (2026), un recueil de poèmes illustrés paru aux éditions Le Lys Bleu. À travers cet ouvrage, elle invite le lecteur à habiter ces moments de "presque-rien" qui font la poésie de la vie.
            </p>
          ) : (
            <>
              <p>
                Hajar Ouhsine combines the scientific rigor of engineering with a unique literary sensibility. Her journey, marked by community engagement and a commitment to intercultural dialogue, fuels a writing style that explores the interstices of existence.
              </p>
              <p>
                After publishing several works, including Qualia (2022) and Fragmented Dreams (2021), she marks a new milestone in her career with the publication in France of "Habiter le presque" (2026), a collection of illustrated poems published by Le Lys Bleu. Through this work, she invites the reader to inhabit those "almost-nothing" moments that create the poetry of life.
              </p>
            </>
          )}
        </div>
        <div className="social-icons">
          <a
            href="https://www.facebook.com/hajar.ohsn/"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <i className="fab fa-facebook-f"></i>
          </a>
          <a
            href="https://www.instagram.com/hajar.author/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://www.youtube.com/@hajarouhsine"
            target="_blank"
            rel="noreferrer"
            aria-label="YouTube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="mailto:Hajar.auteure@gmail.com"
            aria-label="Send an email"
          >
            <i className="fab fa-google"></i>
          </a>
        </div>
      </div>
      <div className="about-image">
        <img src={image1} alt="Hajar Ouhsine" />
      </div>
    </section>
  );
};

export default About;
